import { View } from "../../Core";
import Vue from "vue";
import GallerySlider from "../../Components/GallerySlider/GallerySlider.vue";
import Lightbox from "../../Components/Lightbox/Lightbox.vue";

export class GalleryIndexView extends View<GalleryIndexView> {

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        let v = new Vue({
            el: ".app",
            data: {},
            components: {
                GallerySlider,
                Lightbox
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Gallery/GalleryIndexView.ts